module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/mailbox-a1292ceecd49912e764f0eba63a188c8.svg";